import React, { useEffect, useRef, useState, useCallback } from 'react';
import { gsap } from 'gsap';
import './Achievements.css';

const Achievements = () => {
  const sWrapperRef = useRef(null);
  const slideImageRef = useRef(null);
  const slideDateRef = useRef(null);
  const slideTitleRef = useRef(null);
  const slideTextRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const handleButtonClick = useCallback((next) => {
    setCurrentSlide((prevSlide) => {
      let newSlide;
      const sWrapper = sWrapperRef.current;
      const sItem = sWrapper.querySelectorAll('.slide');
      const sWidth = sItem[0].clientWidth;
      const sCount = sItem.length;
      if (next) {
        newSlide = prevSlide < sCount - 1 ? prevSlide + 1 : 0;
      } else {
        newSlide = prevSlide > 0 ? prevSlide - 1 : sCount - 1;
      }

      gsap.to(sWrapper, { x: `-${sWidth * newSlide}`, duration: 0.4 });

      // CONTENT ANIMATIONS
      const fromProperties = { autoAlpha: 0, x: '-50', y: '-10' };
      const toProperties = { autoAlpha: 0.8, x: '0', y: '0' };

      gsap.fromTo(slideImageRef.current, { autoAlpha: 0, y: '40' }, { autoAlpha: 1, y: '0', duration: 1 });
      gsap.fromTo(slideDateRef.current, fromProperties, { ...toProperties, duration: 0.4 });
      gsap.fromTo(slideTitleRef.current, fromProperties, { ...toProperties, duration: 0.6 });
      gsap.fromTo(slideTextRef.current, fromProperties, { ...toProperties, duration: 0.8 });

      return newSlide;
    });
  }, []);

  useEffect(() => {
    const sWrapper = sWrapperRef.current;
    const sItem = sWrapper.querySelectorAll('.slide');
    const sWidth = sItem[0].clientWidth;
    const sCount = sItem.length;
    const sTotalWidth = sCount * sWidth;

    sWrapper.style.width = `${sTotalWidth}px`;
    gsap.set(sWrapper, { x: 0 });

    // const autoSlideInterval = setInterval(() => handleButtonClick(true), 5000);

    return () => {
      // clearInterval(autoSlideInterval); // Uncomment if autoslide is enabled
    };
  }, [handleButtonClick]);

  return (
    <div className="slider">
      <h1>My<span>Achievements</span></h1>
      <div ref={sWrapperRef} className="slider-wrapper flex">
        {/* Add slides dynamically */}
        {achievementsData.map((achievement, index) => (
          <div key={index} className="slide flex">
            <div className="slide-image">
              <img src={achievement.image} alt={`Slide ${index + 1}`} />
              <div className="overlay"></div>
            </div>
            <div className="slide-content">
              <div ref={slideDateRef} className="slide-date">
                {achievement.date}
              </div>
              <div ref={slideTitleRef} className="slide-title">
                {achievement.title}
              </div>
              <div ref={slideTextRef} className="slide-text">
                {achievement.text}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="arrows">
        <button title="Previous" className="arrow slider-link prev" onClick={() => handleButtonClick(false)}></button>
        <button title="Next" className="arrow slider-link next" onClick={() => handleButtonClick(true)}></button>
      </div>
    </div>
  );
};

const achievementsData = [
  {
    image: require('../../../images/achive/Jetson.jpg'),
    date: 'NVIDIA',
    title: 'AI Specialist',
    text: 'I am proud to hold the Jetson AI Specialist certificate from NVIDIA, which recognizes my expertise in developing AI applications for edge devices using the powerful NVIDIA Jetson platform. This showcases my potential in areas such as computer vision, machine learning, deep learning frameworks, and deploying AI models on edge devices. With this credential, I am equipped to create intelligent solutions for industries such as robotics, computer vision, and autonomous systems.',
  },
  {
    image: require('../../../images/achive/hack.jpg'),
    date: 'Google | AMD | GeeksforGeeks',
    title: 'Hackathon Winner',
    text: 'I am delighted to spotlight my accomplishment in the Institute-Level Hackathon, a collaborative initiative by industry giants Google Cloud, AMD, and esteemed programming community GeeksforGeeks (GFG). Through rigorous competition and unwavering determination, my team and I succeeded in crafting a compelling solution that exemplified our prowess in cloud computing, advanced hardware, and innovative problem-solving.',
  },
  {
    image: require('../../../images/achive/patent.jpg'),
    date: 'Intellectual Property India',
    title: 'Patent - Voice Automated Virtual Ordering System',
    text: "Another significant achievement in my technological journey – the publication of my patent on a revolutionary Voice-Automated Table Service System. This innovative system redefines the dining experience by introducing a hands-free approach to menu selection and ordering. Designed to seamlessly integrate cutting-edge voice recognition technology, this system empowers diners to engage with menus and place orders effortlessly, without the need for traditional menus or direct human interaction.",
  },
  {
    image: require('../../../images/achive/chess.jpg'),
    date: 'District Chess Association',
    title: 'Chess Player',
    text: "I am proud to have secured a prominent position at the district-level chess competition, showcasing my strategic prowess and dedication to the game. Emerging successfully in this challenging competition stands as a testament to my strategic thinking and determination, motivating me to pursue excellence in chess and beyond.",
  },
  {
    image: require('../../../images/achive/rollball.jpg'),
    date: 'State-Level Competition',
    title: 'Roll Ball Player',
    text: 'Having the privilege to compete in the state-level Rollball tournament was a defining moment in my athletic journey.Representing my region at this level was a testament to my dedication to the sport and my commitment to honing my skills.',
  },
  {
    image: require('../../../images/achive/softball.jpg'),
    date: 'State-Level Competition',
    title: 'Soft Ball Player',
    text: 'Participating in the state-level Softball competition was an exhilarating experience that showcased my athletic prowess and team spirit. As a dedicated player, I showcased my skills in throwing, catching, and teamwork on a larger stage, representing my region with pride.',
  }
];

export default Achievements;